module.exports = __webpack_public_path__ + "img/Feature.e5e4508b.png";